/*
 *  National Average Wage Index Series from 1951 - 2021.
 *
 *  See: https://www.ssa.gov/OACT/COLA/AWI.html#Series
 *
 *  This should be updated every year.
 *
 */

export const NATIONAL_AVERAGE_WAGE_INDEX_SERIES = {
  1951: 2799.16,
  1952: 2973.32,
  1953: 3139.44,
  1954: 3155.64,
  1955: 3301.44,
  1956: 3532.36,
  1957: 3641.72,
  1958: 3673.8,
  1959: 3855.8,
  1960: 4007.12,
  1961: 4086.76,
  1962: 4291.4,
  1963: 4396.64,
  1964: 4576.32,
  1965: 4658.72,
  1966: 4938.36,
  1967: 5213.44,
  1968: 5571.76,
  1969: 5893.76,
  1970: 6186.24,
  1971: 6497.08,
  1972: 7133.8,
  1973: 7580.16,
  1974: 8030.76,
  1975: 8630.92,
  1976: 9226.48,
  1977: 9779.44,
  1978: 10556.03,
  1979: 11479.46,
  1980: 12513.46,
  1981: 13773.1,
  1982: 14531.34,
  1983: 15239.24,
  1984: 16135.07,
  1985: 16822.51,
  1986: 17321.82,
  1987: 18426.51,
  1988: 19334.04,
  1989: 20099.55,
  1990: 21027.98,
  1991: 21811.6,
  1992: 22935.42,
  1993: 23132.67,
  1994: 23753.53,
  1995: 24705.66,
  1996: 25913.9,
  1997: 27426.0,
  1998: 28861.44,
  1999: 30469.84,
  2000: 32154.82,
  2001: 32921.92,
  2002: 33252.09,
  2003: 34064.95,
  2004: 35648.55,
  2005: 36952.94,
  2006: 38651.41,
  2007: 40405.48,
  2008: 41334.97,
  2009: 40711.61,
  2010: 41673.83,
  2011: 42979.61,
  2012: 44321.67,
  2013: 44888.16,
  2014: 46481.52,
  2015: 48098.63,
  2016: 48642.15,
  2017: 50321.89,
  2018: 52145.8,
  2019: 54099.99,
  2020: 55628.6,
  2021: 60575.07,
};

/*
 *
 *  Benefit Formula Bend Points
 *
 *  See: https://www.ssa.gov/OACT/COLA/bendpoints.html
 *
 *  This should be updated every year.
 *
 */
export const BEND_POINTS = {
  1979: {
    first: 180,
    second: 1085,
  },
  1980: {
    first: 194,
    second: 1171,
  },
  1981: {
    first: 211,
    second: 1274,
  },
  1982: {
    first: 230,
    second: 1388,
  },
  1983: {
    first: 254,
    second: 1528,
  },
  1984: {
    first: 267,
    second: 1612,
  },
  1985: {
    first: 280,
    second: 1691,
  },
  1986: {
    first: 297,
    second: 1790,
  },
  1987: {
    first: 310,
    second: 1866,
  },
  1988: {
    first: 319,
    second: 1922,
  },
  1989: {
    first: 339,
    second: 2044,
  },
  1990: {
    first: 356,
    second: 2145,
  },
  1991: {
    first: 370,
    second: 2230,
  },
  1992: {
    first: 387,
    second: 2333,
  },
  1993: {
    first: 401,
    second: 2420,
  },
  1994: {
    first: 422,
    second: 2545,
  },
  1995: {
    first: 426,
    second: 2567,
  },
  1996: {
    first: 437,
    second: 2635,
  },
  1997: {
    first: 455,
    second: 2741,
  },
  1998: {
    first: 477,
    second: 2875,
  },
  1999: {
    first: 505,
    second: 3043,
  },
  2000: {
    first: 531,
    second: 3202,
  },
  2001: {
    first: 561,
    second: 3381,
  },
  2002: {
    first: 592,
    second: 3567,
  },
  2003: {
    first: 606,
    second: 3653,
  },
  2004: {
    first: 612,
    second: 3689,
  },
  2005: {
    first: 627,
    second: 3779,
  },
  2006: {
    first: 656,
    second: 3955,
  },
  2007: {
    first: 680,
    second: 4100,
  },
  2008: {
    first: 711,
    second: 4288,
  },
  2009: {
    first: 744,
    second: 4483,
  },
  2010: {
    first: 761,
    second: 4586,
  },
  2011: {
    first: 749,
    second: 4517,
  },
  2012: {
    first: 767,
    second: 4624,
  },
  2013: {
    first: 791,
    second: 4768,
  },
  2014: {
    first: 816,
    second: 4917,
  },
  2015: {
    first: 826,
    second: 4980,
  },
  2016: {
    first: 856,
    second: 5157,
  },
  2017: {
    first: 885,
    second: 5336,
  },
  2018: {
    first: 895,
    second: 5397,
  },
  2019: {
    first: 926,
    second: 5583,
  },
  2020: {
    first: 960,
    second: 5785,
  },
  2021: {
    first: 996,
    second: 6002,
  },
  2022: {
    first: 1024,
    second: 6172,
  },
  2023: {
    first: 1115,
    second: 6721,
  },
};
